export const SITE_NAME = "Rahul Engineering Works";
export const SITE_SHORT_NAME = "REW";
export const SITE_TAGLINE =
  "Bakery Machines, Ovens, Mixers & Slicers — Kanpur, India";

/** Primary search phrases to rank for */
export const PRIMARY_KEYWORDS = [
  "bakery machines",
  "bakery oven",
  "oven",
  "slicer",
  "mixer",
  "kanpur",
  "rahul engineering works kanpur",
  "rahul engineering works",
  "bakery machines kanpur",
  "bakery equipment kanpur",
  "industrial bakery machines",
  "bread slicer kanpur",
  "spiral mixer kanpur",
];

export const SITE_URL =
  process.env.REACT_APP_SITE_URL || "https://rahulengineeringwork.com";

export const DEFAULT_OG_IMAGE = "/hero.webp";
export const LOGO_PATH = "/rew-logo.png";

export const BUSINESS = {
  legalName: "Rahul Engineering Works",
  foundingYear: 1992,
  email: "rahulengineering3@gmail.com",
  phones: ["+918077558106", "+919415161097"],
  gst: "09ACSPC3613R1Z1",
  address: {
    streetAddress: "F-29, Site-5, Road No. 6, Udyog Kunj, Panki",
    addressLocality: "Kanpur",
    addressRegion: "Uttar Pradesh",
    postalCode: "208022",
    addressCountry: "IN",
  },
  geo: {
    latitude: 26.449514,
    longitude: 80.271431,
  },
  social: {
    instagram: "https://www.instagram.com/rew_bakerymachines",
    facebook: "https://www.facebook.com/profile.php?id=100087019674735",
  },
};

export const SEO_KEYWORDS = [
  ...PRIMARY_KEYWORDS,
  "REW bakery machines",
  "bakery equipment manufacturer India",
  "industrial bakery machinery",
  "commercial bakery equipment",
  "bread making machine",
  "rusk making machine",
  "biscuit making machinery",
  "rotary rack oven",
  "tunnel oven",
  "swing tray oven",
  "spiral dough mixer",
  "planetary mixer",
  "high speed mixer",
  "bread slicer machine",
  "rusk production line",
  "automatic bakery plant",
  "bakery conveyor",
  "rahul engineering kanpur",
  "bakery machine manufacturer uttar pradesh",
  "panki kanpur bakery machines",
  "udyog kunj bakery equipment",
];

export const toAbsoluteUrl = (path = "/") => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  if (normalizedPath === "/") return SITE_URL;
  return `${SITE_URL}${normalizedPath}`;
};

export const toProductSlug = (name) =>
  name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
